'use strict'

import React from 'react'
import InfoIcon from '../productServiceCard/images/info-new.svg'
import './BatteryServiceCard.css'

function BatteryServiceCard (props) {

  return (
    <div className="protect-guarantee-list-item">
      <div className="protect-guarantee-content">
        <input type="radio"
               name="battery-service"
               id={`battery-service-${props.ID}`}
               value={props.ID}
               onChange={props.onCheckBatteryService}
               checked={parseInt(props.checkedBatteryServiceId) === parseInt(props.ID)}/>
        <label htmlFor={`battery-service-${props.ID}`}>
          <div className="protect-guarantee-item-into">
            <span className="protect-guarantee-item-title">
              <span>{props.NAME}</span>
              <span className="open-services-modal">
                <img src={InfoIcon}
                     width="14px"
                     height="14px"
                     title="info"/>
                <div className="tooltip-text">
                    <div className="tooltip-text-holder">
                        <div className="tooltip-box">
                            <p>{props.PREVIEW_TEXT}</p>
                        </div>
                    </div>
                </div>
              </span>
            </span>
            <span className="protect-guarantee-item-price">{props.PRICE['PRINT_PRICE']}</span>
          </div>
        </label>
      </div>
    </div>
  )
}

export default BatteryServiceCard
